<template>
<div id="poi-groups-wrapper">
  <!-- 小程序版 -->
  <van-popup v-model="showPopup"
            :overlay="true"
            :position="position">
    <div class="drawer" :class="{'top': from}">
      <div class="poi-groups">
        <div class="poi-group"
            :class="{'active': active === -1}"
            @click="handleClick(-1)">
          <div class="icon">
            <img src="/image/poi/all.svg" class="all" />
          </div>
          <div class="text">{{ $t('home.all') }}</div>
        </div>
        <div class="poi-group"
            :class="{'active': active === index}"
            v-for="(item, index) in poiGroups"
            :key="item.id"
            @click="handleClick(index)">
          <div class="icon" v-if="item.poi_type!=='site_image'">
            <img :src="item.image_url" />
          </div>
          <div class="icon" v-else>
            <img src="../../public/image/poi/360@2x.png" />
          </div>
          <div class="text">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </van-popup>
  <!-- 网页版 -->
  <van-dialog v-model="showModal"
              width="351"
              :showConfirmButton="false"
              :closeOnClickOverlay="true">
    <div class="group-container">
      <div class="poi-groups">
        <div class="poi-group"
            :class="{'active': active === -1}"
            @click="handleClick(-1)">
          <div class="icon">
            <img src="/image/poi/all.svg" class="all" />
          </div>
          <div class="text">{{ $t('home.all') }}</div>
        </div>
        <div class="poi-group"
            :class="{'active': active === index}"
            v-for="(item, index) in poiGroups"
            :key="item.id"
            @click="handleClick(index)">
          <div class="icon" v-if="item.poi_type!=='site_image'">
            <img :src="item.image_url" />
          </div>
          <div class="icon" v-else>
            <img src="../../public/image/poi/360@2x.png" />
          </div>
          <div class="text">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </van-dialog>
</div>
</template>

<script>
import { Popup } from 'vant'
import 'vant/lib/popup/style'
import 'vant/lib/dialog/style'

export default {
  data () {
    return {
      displayPoi: false,
      showPopup: false,
      showModal: false,
      currentEnv: ''
    }
  },
  props: {
    active: {
      type: Number,
      default: -1
    },
    poiGroups: {
      type: Array,
      default: () => {
        return []
      }
    },
    position: {
      type: String,
      default: 'bottom'
    },
    from: {
      type: String,
      default: ''
    }
  },
  components: {
    'van-popup': Popup
  },
  methods: {
    show (type) {
      this.currentEnv = type
      if (type) {
        this.showPopup = true
      } else {
        this.showModal = true
      }
    },
    hide () {
      this.showPopup = false
      this.showModal = false
    },
    handleClick (index) {
      this.$emit('select', index)
      this.showPopup = false
      this.showModal = false
    }
  }
}
</script>

<style lang="scss">
.drawer.top {
  padding-top: 40px;
  max-height: 550px;
  overflow: auto;
}

.group-container {
  max-height: 500px;
  overflow: auto;
}

.poi-groups {
  display: flex;
  flex-wrap: wrap;
  padding: 6px 23px 20px;

  .poi-group {
    margin-top: 12px;
    font-size: 14px;
    line-height: 20px;
    color: #222125;
    text-align: center;
    width: 25%;
    padding: 12px 0 8px;

    &.active {
      background-color: #f1f1f1;
      
      .text {
        font-weight: bold;
        font-family: GothamBold;
      }
    }
  }

  .icon {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 2px;
  }

  .all {
    width: 30px;
    height: 30px;
  }

  img {
    width: 32px;
    height: 32px;
    display: block;
  }
}
</style>
